export default [
  {
    path: '/export',
    name: 'export',
    component: () => import('@/views/export/Index.vue'),
    children: [
      {
        path: 'addison',
        name: 'export.addison.liste',
        component: () => import('@/views/export/addison/Liste.vue'),
      },
    ],
  },
];
